module.exports = __webpack_public_path__ + "img/bg-old.0d17897c.png";